import { THttpService } from '@/services/HttpService';

import { getValue } from '@/helpers/GetValueHelper';

const formatSuccess = (data: { htmlContent: string }) => {
  return getValue(data, 'htmlContent', '');
};

const formatError = () => {
  return 'error';
};

export const getRules = async (
  api: THttpService,
  portalId: string,
  searchId: string,
): Promise<string> => {
  const query = new URLSearchParams({
    portalId,
    searchId,
  }).toString();

  const path = `/api/jsonws/liferay-content-service-portlet.commoncontent/get-common-content`;

  try {
    const response = await api.get(`${path}?${query}`, { credentials: 'omit' });
    if (getValue(response, 'htmlContent', '')) {
      return formatSuccess(response);
    }
    return formatError();
  } catch (error) {
    return formatError();
  }
};
